import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {

  // Inputs
  @Input() tooltipText: string = '';
  @Input() link: boolean = false;
  @Input() linkText: string = '';
  @Input() linkRef: string = '';
  @Input() tooltipIcon: string = './assets/images/ico-tooltip.svg';
  @Input() tooltipTheme: string = '';
  @Input() tooltipRightSide: boolean = true;
  @Input() tooltipBottomSide: boolean = false;

  // Constructor
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tooltip/tooltip.component.ts